(function () {
  'use strict';

  // ── BOLSAS (suscripcion-bolsas-de-cafe, product 16326942622041) ──────────
  // Key: "cantidad|perfil" → variant ID
  var BOLSAS_PLAN = 689619009881;
  var BOLSAS_VM = {
    '1x 250g|Achocolatado':            58161172644185,
    '1x 250g|Afrutado/Floral':         58161172676953,
    '1x 250g|Descafeinado':            58161177821529,
    '1x 250g|Preferido del tostador':  58161172709721,
    '2x 250g|Achocolatado':            58161173430617,
    '2x 250g|Afrutado/Floral':         58161173463385,
    '2x 250g|Descafeinado':            58161177854297,
    '2x 250g|Preferido del tostador':  58161173496153,
    '3x 250g|Achocolatado':            58161174217049,
    '3x 250g|Afrutado/Floral':         58161174249817,
    '3x 250g|Descafeinado':            58161177887065,
    '3x 250g|Preferido del tostador':  58161174282585,
    '1x 1kg|Achocolatado':             58161175003481,
    '1x 1kg|Afrutado/Floral':          58161175036249,
    '1x 1kg|Descafeinado':             58161177919833,
    '1x 1kg|Preferido del tostador':   58161175069017
  };

  var BOLSAS_PRICES = {
    '1x 250g': 1300,
    '2x 250g': 2200,
    '3x 250g': 3100,
    '1x 1kg':  4000
  };

  var BOLSAS_LABELS = {
    '1x 250g': '1 bolsa · 250g',
    '2x 250g': '2 bolsas · 500g',
    '3x 250g': '3 bolsas · 750g',
    '1x 1kg':  '1 bolsa · 1kg'
  };

  // ── CÁPSULAS (capsulas-de-especialidad) ───────────────────────────────────
  var CAPS_PLAN = 689621959001;
  var CAPS_VM = {
    'Achocolatado': 47262053106009,
    'Afrutado':     47262053138777,
    'Descafeinado': 54417588486489
  };
  var CAPS_BASE_PRICE  = 950;   // 9.50€ base
  var CAPS_DISCOUNT    = 0.075; // 7.5% Appstle discount
  var CAPS_PRICE = Math.round(CAPS_BASE_PRICE * (1 - CAPS_DISCOUNT)); // 879 cents = 8.79€

  // ── State ─────────────────────────────────────────────────────────────────
  var state = {
    formato:  null,  // 'bolsa' | 'capsulas'
    cantidad: null,  // bolsas only: '1x 250g' etc.
    perfil:   null,  // bolsas: 'Achocolatado'|'Afrutado/Floral'|'Preferido del tostador'
                     // caps:   'Achocolatado'|'Afrutado'|'Descafeinado'
    tipo:     null,  // bolsas only: 'En grano' | method name
    capsQty:  1      // capsulas quantity
  };

  var currentStep = 1;

  var quiz = document.getElementById('sub-quiz');
  if (!quiz) return;

  var progressBar = quiz.querySelector('#sqProgressBar');
  var stepLabel   = quiz.querySelector('#sqStepLabel');
  var backBtn     = quiz.querySelector('#sqBack');
  var metodos     = quiz.querySelector('#sqMetodos');
  var resultTitle = quiz.querySelector('#sqResultTitle');
  var resultPrice = quiz.querySelector('#sqResultPrice');
  var resultMeta  = quiz.querySelector('#sqResultMeta');
  var ctaBtn      = quiz.querySelector('#sqCta');
  var restartBtn  = quiz.querySelector('#sqRestart');

  // Steps by formato: bolsa = [1,2,3,4], capsulas = [1,3,5] (skip 2 and 4)
  var BOLSA_STEPS  = [1, 2, 3, 4];
  var CAPS_STEPS   = [1, 3];
  var TOTAL_BOLSA  = 4;
  var TOTAL_CAPS   = 2;

  function totalSteps() {
    return state.formato === 'capsulas' ? TOTAL_CAPS : TOTAL_BOLSA;
  }

  function stepIndex() {
    var steps = state.formato === 'capsulas' ? CAPS_STEPS : BOLSA_STEPS;
    var idx = steps.indexOf(currentStep);
    return idx >= 0 ? idx + 1 : currentStep;
  }

  function updateUI() {
    var total = totalSteps();
    var idx   = stepIndex();
    var pct   = currentStep > (state.formato === 'capsulas' ? 3 : 4) ? 100
               : Math.round((idx - 1) / total * 100);
    progressBar.style.width = pct + '%';
    var pctEl = quiz.querySelector('#sqProgressPct');
    if (pctEl) pctEl.textContent = currentStep === 5 ? '' : pct + '%';

    if (currentStep === 5) {
      stepLabel.textContent = '¡Listo!';
    } else {
      stepLabel.textContent = 'Paso ' + idx + ' de ' + total;
    }

    backBtn.classList.toggle('sq-hidden', currentStep <= 1);
  }

  function showStep(n) {
    quiz.querySelectorAll('.sub-quiz__step').forEach(function (el) {
      el.classList.remove('active');
    });
    var target = quiz.querySelector('[data-step="' + n + '"]');
    if (target) target.classList.add('active');
    currentStep = n;
    updateUI();
    var top = quiz.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function clearStep(n) {
    var keyMap = { 2: 'cantidad', 3: 'perfil', 4: 'tipo' };
    var k = keyMap[n];
    if (k) {
      state[k] = null;
      quiz.querySelectorAll('[data-key="' + k + '"]').forEach(function (b) {
        b.classList.remove('selected');
      });
    }
    if (n === 4) {
      state.tipo = null;
      quiz.querySelectorAll('.sub-quiz__metodo').forEach(function (b) {
        b.classList.remove('selected');
      });
      metodos.classList.remove('visible');
    }
  }

  function formatPrice(cents) {
    var eur = cents / 100;
    return eur.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  function showResult() {
    var variantId, price, titleText, metaText, planId;
    var qtyWrap = quiz.querySelector('#sqCapsQty');

    if (state.formato === 'capsulas') {
      variantId = CAPS_VM[state.perfil];
      price     = CAPS_PRICE * state.capsQty;
      titleText = state.capsQty + (state.capsQty === 1 ? ' caja' : ' cajas') + ' · 14 cápsulas';
      metaText  = state.perfil + ' · Nespresso · ' + formatPrice(CAPS_PRICE) + '/caja';
      planId    = CAPS_PLAN;
      if (qtyWrap) qtyWrap.style.display = '';
      updateQtyDisplay();
    } else {
      variantId = BOLSAS_VM[state.cantidad + '|' + state.perfil];
      price     = BOLSAS_PRICES[state.cantidad] || 0;
      titleText = BOLSAS_LABELS[state.cantidad] || state.cantidad;
      var tipoLabel = state.tipo === 'En grano' ? 'En grano' : 'Molido · ' + state.tipo;
      metaText  = tipoLabel + ' · ' + state.perfil;
      planId    = BOLSAS_PLAN;
      if (qtyWrap) qtyWrap.style.display = 'none';
    }

    if (!variantId) {
      console.warn('HMC Quiz: variant not found for state:', state);
      return;
    }

    resultTitle.textContent = titleText;
    resultPrice.textContent = formatPrice(price) + '/mes';
    resultMeta.textContent  = metaText;
    ctaBtn.dataset.variantId  = String(variantId);
    ctaBtn.dataset.planId     = String(planId);
    ctaBtn.disabled = false;
    ctaBtn.textContent = 'SUSCRIBIRME';

    showStep(5);
  }

  function updateQtyDisplay() {
    var qtyNum = quiz.querySelector('#sqQtyNum');
    var resultTitleEl = quiz.querySelector('#sqResultTitle');
    var resultPriceEl = quiz.querySelector('#sqResultPrice');
    if (qtyNum) qtyNum.textContent = state.capsQty;
    if (resultTitleEl) resultTitleEl.textContent = state.capsQty + (state.capsQty === 1 ? ' caja' : ' cajas') + ' · 14 cápsulas';
    if (resultPriceEl) resultPriceEl.textContent = formatPrice(CAPS_PRICE * state.capsQty) + '/mes';
  }

  quiz.addEventListener('click', function (e) {

    // Option buttons
    var opt = e.target.closest('.sub-quiz__option:not(:disabled):not(.sub-quiz__option--disabled)');
    if (opt) {
      var key = opt.dataset.key;
      var val = opt.dataset.value;
      quiz.querySelectorAll('[data-key="' + key + '"]').forEach(function (b) {
        b.classList.remove('selected');
      });
      opt.classList.add('selected');

      if (key === 'formato') {
        state.formato = val;
        // Show correct perfil options for this formato
        var bolsasOpts = quiz.querySelector('.sub-quiz__perfil-bolsas');
        var capsOpts   = quiz.querySelector('.sub-quiz__perfil-capsulas');
        if (bolsasOpts) bolsasOpts.style.display = val === 'capsulas' ? 'none' : '';
        if (capsOpts)   capsOpts.style.display   = val === 'capsulas' ? '' : 'none';
        if (val === 'capsulas') {
          showStep(3); // skip cantidad step
        } else {
          showStep(2);
        }

      } else if (key === 'cantidad') {
        state.cantidad = val;
        showStep(3);

      } else if (key === 'perfil') {
        state.perfil = val;
        if (state.formato === 'capsulas') {
          showResult(); // cápsulas: no tipo step
        } else {
          showStep(4);
        }

      } else if (key === 'tipo') {
        if (val === 'En grano') {
          state.tipo = 'En grano';
          metodos.classList.remove('visible');
          showResult();
        } else {
          metodos.classList.add('visible');
        }
      }
      return;
    }

    // Method buttons (molido)
    var metodo = e.target.closest('.sub-quiz__metodo');
    if (metodo) {
      quiz.querySelectorAll('.sub-quiz__metodo').forEach(function (b) {
        b.classList.remove('selected');
      });
      metodo.classList.add('selected');
      state.tipo = metodo.dataset.metodo;
      setTimeout(showResult, 180);
      return;
    }

    // CTA — add to cart
    if (e.target.closest('#sqCta')) {
      var vId    = parseInt(ctaBtn.dataset.variantId, 10);
      var planId = parseInt(ctaBtn.dataset.planId, 10);
      if (!vId) return;

      var qty  = state.formato === 'capsulas' ? state.capsQty : 1;
      var body = { id: vId, quantity: qty, selling_plan: planId };

      if (state.formato === 'bolsa') {
        var props = {};
        if (state.tipo === 'En grano') {
          props['Tipo'] = 'En grano';
        } else {
          props['Tipo']   = 'Molido';
          props['Método'] = state.tipo.replace('Molido - ', '');
        }
        body.properties = props;
      }

      ctaBtn.disabled = true;
      ctaBtn.textContent = '...';

      fetch('/cart/add.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () { window.location = '/cart'; })
      .catch(function (err) {
        console.error('HMC Quiz cart error:', err);
        var msg = (err && err.description) ? err.description : (err && err.message) ? err.message : JSON.stringify(err);
        var errEl = quiz.querySelector('#sqError');
        if (errEl) { errEl.textContent = msg; errEl.style.display = 'block'; }
        ctaBtn.disabled = false;
        ctaBtn.textContent = 'SUSCRIBIRME';
      });
      return;
    }

    // Quantity controls (cápsulas)
    if (e.target.closest('#sqQtyMinus')) {
      if (state.capsQty > 1) { state.capsQty--; updateQtyDisplay(); }
      return;
    }
    if (e.target.closest('#sqQtyPlus')) {
      if (state.capsQty < 10) { state.capsQty++; updateQtyDisplay(); }
      return;
    }

    // Restart
    if (e.target.closest('#sqRestart')) {
      state = { formato: null, cantidad: null, perfil: null, tipo: null, capsQty: 1 };
      quiz.querySelectorAll('.sub-quiz__option, .sub-quiz__metodo').forEach(function (b) {
        b.classList.remove('selected');
      });
      metodos.classList.remove('visible');
      showStep(1);
      return;
    }

    // Back
    if (e.target.closest('#sqBack')) {
      if (currentStep <= 1) return;

      // Step 4: if methods visible, hide them first
      if (currentStep === 4 && metodos.classList.contains('visible')) {
        metodos.classList.remove('visible');
        quiz.querySelectorAll('[data-key="tipo"]').forEach(function (b) {
          b.classList.remove('selected');
        });
        state.tipo = null;
        return;
      }

      // From result (step 5): go back to last question
      if (currentStep === 5) {
        if (state.formato === 'capsulas') {
          clearStep(3);
          showStep(3);
        } else {
          clearStep(4);
          showStep(4);
        }
        return;
      }

      // From step 3 with cápsulas: go back to step 1
      if (currentStep === 3 && state.formato === 'capsulas') {
        clearStep(3);
        state.formato = null;
        quiz.querySelectorAll('[data-key="formato"]').forEach(function (b) {
          b.classList.remove('selected');
        });
        showStep(1);
        return;
      }

      var prev = currentStep - 1;
      clearStep(currentStep);
      showStep(prev);
      return;
    }
  });

  // Landing hero → mostrar quiz
  var startBtn = document.getElementById('sqStartQuiz');
  var landing  = document.getElementById('sub-landing');

  if (startBtn && landing) {
    startBtn.addEventListener('click', function () {
      landing.style.display = 'none';
      quiz.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
      showStep(1);
    });
  }
})();

// Color azul en la última línea del título hero
(function () {
  var title = document.querySelector('.sub-landing__title');
  if (!title) return;
  var nodes = title.childNodes;
  for (var i = nodes.length - 1; i >= 0; i--) {
    if (nodes[i].nodeType === 3 && nodes[i].textContent.trim()) {
      var span = document.createElement('span');
      span.style.color = '#3d7ded';
      title.insertBefore(span, nodes[i]);
      span.appendChild(nodes[i]);
      break;
    }
  }
})();
